export default __webpack_public_path__ + "static/media/11_3.42d9a914.png";